import type { IMerge } from "@framework/types";
import { cleanUpAsset } from "@framework/exchange";

export const mergeCreateFilter = ({ item, price }: IMerge) => ({
  item: cleanUpAsset(item) as any,
  price: cleanUpAsset(price) as any,
});

export const mergeEditFilter = ({ item, price, mergeStatus }: IMerge) => ({
  item: cleanUpAsset(item) as any,
  price: cleanUpAsset(price) as any,
  mergeStatus,
});

export const prepareMergeInitialValues = ({ id, item, price, mergeStatus }: Partial<IMerge>) => {
  return {
    id,
    item,
    price,
    mergeStatus,
  };
};
